<template>
    <div class='bgWhite'>
        <div class="logoBox" @click='toIndex'><img src="@/assets/imgs/logo.png" alt=""></div>

        <!-- 新增：登录方式切换Tab栏 -->
        <div class="loginTab">
            <div
                    :class="['tabItem', loginType === 'code' && 'active']"
                    @click="switchLoginType('code')"
            >
                验证码登录
            </div>
            <div
                    :class="['tabItem', loginType === 'pwd' && 'active']"
                    @click="switchLoginType('pwd')"
            >
                密码登录
            </div>
            <div
                    :class="['tabItem', loginType === 'wx' && 'active']"
                    @click="switchLoginType('wx')"
            >
                微信登录
            </div>
        </div>

        <!-- 验证码登录面板 - 原有逻辑，保留 -->
        <div class='loginBox' v-show="loginType === 'code'">
            <div>
                <label>手机号</label>
                <div>
                    <input
                            type="number"
                            placeholder="请输入手机号"
                            pattern="[0-9]*"
                            oninput="if(value.length>11)value=value.slice(0,11)"
                            @focus='instie'
                            v-model="telNumber"
                    >
                    <p>
                        <span v-show='telMsg' class='error'>{{telMsg}}</span>
                        <span class='cancel' @click.stop='toEmptyTel' v-show="telNumber"></span>
                    </p>
                </div>
            </div>
            <div>
                <label>验证码</label>
                <div>
                    <input
                            type="text"
                            placeholder="请输入验证码"
                            maxlength="6"
                            v-model='ercode'
                    >
                    <p>
                        <span v-show='codeMsg' class='error'>{{codeMsg}}</span>
                        <i></i>
                        <em @click.stop='toGetCode' :class="{disabled: isSend}">
                            {{isSend?second+'s':'获取验证码'}}
                        </em>
                    </p>
                </div>
            </div>
        </div>

        <!-- 新增：密码登录面板 -->
        <div class='loginBox' v-show="loginType === 'pwd'">
            <div>
                <label>手机号</label>
                <div>
                    <input
                            type="number"
                            placeholder="请输入手机号"
                            pattern="[0-9]*"
                            oninput="if(value.length>11)value=value.slice(0,11)"
                            @focus='instie'
                            v-model="telNumber"
                    >
                    <p>
                        <span v-show='telMsg' class='error'>{{telMsg}}</span>
                        <span class='cancel' @click.stop='toEmptyTel' v-show="telNumber"></span>
                    </p>
                </div>
            </div>
            <div>
                <label>密码</label>
                <div>
                    <input
                            :type="showPwd ? 'text' : 'password'"
                            placeholder="请输入6-18位密码"
                            maxlength="18"
                            v-model='pwd'
                    >
                    <p>
                        <span v-show='pwdMsg' class='error'>{{pwdMsg}}</span>
                        <i></i>
                        <!-- 密码显示/隐藏切换 -->
                        <em @click.stop='togglePwdShow'>{{showPwd?'隐藏':'显示'}}</em>
                        <!-- 密码清空按钮 -->
                        <span class='cancel' @click.stop='toEmptyPwd' v-show="pwd"></span>
                    </p>
                </div>
            </div>
        </div>

        <!-- 登录按钮 - 动态禁用，根据当前登录类型判断 -->
        <div class="loginBtn" :class="isEmpty?'':'blue'" @click='toLoginFn' :disabled="isEmpty" v-show="loginType !== 'wx'">
            登录
        </div>

        <!-- 微信登录面板 - 整合到tab，保留原有图标 -->
        <div class="wxLoginBox" v-show="loginType === 'wx'">
            <div class="wxIcon" @click='toWxlogin'>
                <img src="@/assets/imgs/icon_wx.png" alt="微信登录">
            </div>
            <p class="wxTip">请点击图标进行微信快捷登录</p>
        </div>

        <beian></beian>
    </div>
</template>

<script>
    import { isPhone, domain, isWexinmobile } from '@/utils/utils.js'
    import { mapActions } from 'vuex'
    import beian from "./common/footer"
    export default {
        data() {
            return {
                loginType: 'code', // 核心：当前登录类型 code-验证码 pwd-密码 wx-微信
                isEmpty: true,     // 登录按钮禁用状态
                telNumber: '',     // 手机号
                ercode: '',        // 验证码
                pwd: '',           // 新增：密码
                second: 60,        // 验证码倒计时
                isSend: false,     // 验证码是否已发送
                telMsg: '',        // 手机号错误提示
                codeMsg: '',       // 验证码错误提示
                pwdMsg: '',        // 新增：密码错误提示
                showPwd: false,    // 新增：密码是否显示
                timer: null        // 定时器实例（优化：统一管理，方便销毁）
            };
        },
        components: { beian },
        created() {},
        // 优化：组件销毁时清除定时器，避免内存泄漏
        beforeDestroy() {
            this.timer && clearInterval(this.timer);
        },
        methods: {
            ...mapActions([
                'getSend',
                'toLogin',
                'toLoginByPwd', // 新增：需在vuex中定义【密码登录】action（与验证码登录接口分离）
                'setLoginInfo',
                'setLoginStus',
                'setNavRoute'
            ]),
            // 首页跳转 - 保留原有
            toIndex() {
                this.$router.push({ name: 'home' })
            },
            // 核心：切换登录方式
            switchLoginType(type) {
                this.loginType = type;
                // 切换时重置所有状态，避免数据残留
                this.resetLoginState(type);
            },
            // 重置登录状态 - 根据切换的类型，保留必要数据（如手机号）
            resetLoginState(type) {
                // 清空非当前类型的输入值和提示
                if (type !== 'code') {
                    this.ercode = '';
                    this.codeMsg = '';
                    this.isSend = false;
                    this.second = 60;
                }
                if (type !== 'pwd') {
                    this.pwd = '';
                    this.pwdMsg = '';
                    this.showPwd = false;
                }
                // 微信登录无需输入，直接启用按钮
                if (type === 'wx') {
                    this.isEmpty = false;
                    return;
                }
                // 验证码/密码登录，重新判断按钮状态
                this.checkInputStatus();
            },
            // 微信登录 - 保留原有，优化提示文案
            toWxlogin() {
                if (isWexinmobile()) {
                    window.location.href = domain + 'Wechat/wxLogin'
                } else {
                    this.$toast('请在微信客户端打开进行登录')
                }
            },
            // 手机号输入框聚焦 - 保留原有
            instie() {},
            // 获取验证码 - 保留原有，优化校验
            async toGetCode() {
                const tel = this.telNumber;
                // 手机号非空+格式校验
                if (!tel) {
                    this.telMsg = '请输入手机号码';
                    return;
                }
                if (!isPhone(tel)) {
                    this.telMsg = '手机号码格式错误';
                    return;
                }
                // 开始倒计时
                this.isSend = true;
                this.startTimer();
                // 发送验证码请求
                try {
                    const res = await this.getSend({ mobile: tel });
                    if (res.code === '1') {
                        this.$toast('验证码发送成功');
                        this.checkInputStatus();
                    } else {
                        this.$toast(res.msg);
                        this.isSend = false; // 失败后重置发送状态
                    }
                } catch (err) {
                    this.$toast('验证码发送失败，请重试');
                    this.isSend = false;
                }
            },
            // 优化：定时器 - 简化逻辑，统一管理
            startTimer() {
                this.timer && clearInterval(this.timer); // 清除旧定时器
                this.second = 60;
                this.timer = setInterval(() => {
                    this.second--;
                    if (this.second <= 0) {
                        clearInterval(this.timer);
                        this.second = 60;
                        this.isSend = false;
                        this.timer = null;
                    }
                }, 1000);
            },
            // 核心：统一登录方法 - 根据当前登录类型处理
            async toLoginFn() {
                // 微信登录直接执行原有逻辑
                if (this.loginType === 'wx') {
                    this.toWxlogin();
                    return;
                }
                // 公共校验：手机号
                const tel = this.telNumber;
                if (!tel) {
                    this.telMsg = '请输入手机号码';
                    return;
                }
                if (!isPhone(tel)) {
                    this.telMsg = '手机号码格式错误';
                    return;
                }
                // 验证码登录专属校验
                if (this.loginType === 'code') {
                    const ercode = this.ercode;
                    if (!ercode) {
                        this.codeMsg = '请输入验证码';
                        return;
                    }
                    // 验证码登录请求
                    this.handleCodeLogin(tel, ercode);
                    return;
                }
                // 密码登录专属校验
                if (this.loginType === 'pwd') {
                    const pwd = this.pwd;
                    if (!pwd) {
                        this.pwdMsg = '请输入密码';
                        return;
                    }
                    // 密码格式校验（6-18位，字母/数字/下划线）
                    if (!/^[a-zA-Z0-9_]{6,18}$/.test(pwd)) {
                        this.pwdMsg = '密码为6-18位字母、数字';
                        return;
                    }
                    // 密码登录请求
                    this.handlePwdLogin(tel, pwd);
                    return;
                }
            },
            // 验证码登录请求 - 提取原有逻辑
            async handleCodeLogin(tel, ercode) {
                try {
                    const res = await this.toLogin({
                        mobile: tel,
                        verification_code: ercode
                    });
                    this.handleLoginResult(res);
                } catch (err) {
                    this.$toast('登录请求失败，请重试');
                }
            },
            // 新增：密码登录请求
            async handlePwdLogin(tel, pwd) {
                try {
                    const res = await this.toLoginByPwd({
                        //mobile: tel,
                        username: tel,//后台接收为username
                        password: pwd // 密码参数，与后端接口保持一致
                    });
                    this.handleLoginResult(res);
                } catch (err) {
                    this.$toast('登录请求失败，请重试');
                }
            },
            // 统一处理登录结果 - 提取公共逻辑，减少冗余
            handleLoginResult(res) {
                console.log('登录结果:', 333);
                if (res.code == '1') {
                    try {
                        console.log('设置登录信息...');
                        this.setLoginInfo(res.data);
                        this.setLoginStus(true);
                        console.log('当前登录状态:', 666);

                        this.$toast('登录成功');
                        //this.$router.push({ name: 'home' });
                        this.setNavRoute();
                    } catch (error) {
                        console.error('设置登录状态出错:', error);
                        // 即使设置状态出错，也尝试跳转
                        //this.$toast('登录成功，即将跳转...');
                        this.$router.push({ name: 'home' });
                    }
                } else {
                    const tip = res.msg == "用户不存在!" ? '该账号未注册，请先验证注册' : res.msg;
                    this.$toast(tip);
                }

            },
            // 优化：合并原有getVal/getVal2，统一输入监听
            checkInputStatus() {
                const tel = this.telNumber;
                // 根据当前登录类型判断输入是否完整
                if (this.loginType === 'code') {
                    const ercode = this.ercode;
                    this.isEmpty = !tel || !ercode;
                    ercode && (this.codeMsg = ''); // 输入验证码后清空错误提示
                }
                if (this.loginType === 'pwd') {
                    const pwd = this.pwd;
                    this.isEmpty = !tel || !pwd;
                    pwd && (this.pwdMsg = ''); // 输入密码后清空错误提示
                }
                // 输入手机号后清空错误提示
                tel && (this.telMsg = '');
            },
            // 手机号清空 - 保留原有，优化状态更新
            toEmptyTel() {
                this.telNumber = '';
                this.checkInputStatus();
            },
            // 新增：密码清空
            toEmptyPwd() {
                this.pwd = '';
                this.checkInputStatus();
            },
            // 新增：密码显示/隐藏切换
            togglePwdShow() {
                this.showPwd = !this.showPwd;
            }
        },
        // 新增：监听输入值变化，自动更新按钮状态（替代原有@input绑定）
        watch: {
            telNumber: {
                handler() {
                    this.checkInputStatus();
                },
                immediate: true
            },
            ercode() {
                this.checkInputStatus();
            },
            pwd() {
                this.checkInputStatus();
            }
        }
    };
</script>

<style scoped>
    /* 原有样式保留，新增以下样式 */
    /* 登录方式Tab栏样式 */
    .loginTab {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 44px;
        background: #fff;
        border-bottom: 1px solid #f1f0f0;
        margin-bottom: 20px;
    }
    .tabItem {
        font-size: 15px;
        color: #666;
        position: relative;
        cursor: pointer;
    }
    .tabItem.active {
        color: #00878b;
    }
    .tabItem.active::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #00878b;
    }

    /* 密码登录相关样式（复用原有，新增少量） */
    .loginBox > div input {
        width: 100%; /* 优化：输入框宽度自适应 */
    }
    .cancel {
        cursor: pointer;
    }
    em.disabled {
        color: #999;
        pointer-events: none; /* 倒计时中禁止点击 */
    }

    /* 微信登录面板样式 */
    .wxLoginBox {
        text-align: center;
        padding: 60px 0;
        background: #fff;
    }
    .wxIcon {
        width: 80px;
        height: 80px;
        margin: 0 auto;
        cursor: pointer;
    }
    .wxIcon img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .wxTip {
        margin-top: 20px;
        font-size: 14px;
        color: #666;
    }

    /* 原有样式保留 */
    .logoBox{
        width:100%;
        padding:19px 0 55.5px 0;
        text-align:center;
        background-color:#fff;
    }
    .logoBox img{
        width:65.5px;
    }
    .loginBox{
        padding:0px 37.5px 0 37.5px;
        background-color:#fff;

    }
    .loginBox>div{
        display:flex;
        flex-direction:column;
        justify-content: flex-start;
        border-bottom:1px solid #f1f0f0;

    }
    .loginBox>div:nth-child(2){
        margin-top:32.5px;
    }
    .loginBox label{
        color:#333333;
        font-size:14px;
        margin-bottom:9px;
        text-align: left;
    }

    .loginBox>div div{
        display:flex;
        justify-content:space-between;
        align-items:center;
        -webkit-user-select:text!important;
    }
    .loginBox>div p{
        display:flex;
        flex-wrap:nowrap;
        align-items:center;
    }

    .loginBox>div i{
        display:block;
        width:1PX;
        height:21px;
        background-color:#f1f0f0;
        margin:0 8px;
    }

    .loginBox>div  input{
        width:120px;
        color:#333333;
        font-size:13px;
        border:0;
        height:39px;
        -webkit-user-select:text!important;
    }

    .error{
        color:#F34740;
        font-size:12px;
    }
    .cancel{
        display:block;
        width:29px;
        height:25px;
        background-repeat:no-repeat;
        background-position:50%;
        background-image:url('../assets/imgs/clear.png');
        background-size:14px 14px;

    }
    em{
        color:#00878b;
        font-size:12px;
        cursor: pointer;
    }

    .loginBtn{
        width:300px;
        height:45px;
        background:#dedede;
        border-radius:22.5px;
        color:#ffffff;
        letter-spacing:3px;
        font-size:16px;
        line-height:45px;
        margin:0 auto;
        text-align:center;
        margin-top:64px;
        cursor: pointer;
    }
    .loginBtn.blue{
        background:#00878b;
    }
    .loginBtn[disabled] {
        opacity: 0.6;
        pointer-events: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/login.vue